import { render, staticRenderFns } from "./Company_Edit.vue?vue&type=template&id=31537dda&scoped=true&"
import script from "./Company_Edit.vue?vue&type=script&lang=ts&"
export * from "./Company_Edit.vue?vue&type=script&lang=ts&"
import style0 from "./Company_Edit.vue?vue&type=style&index=0&id=31537dda&lang=scss&scoped=true&"
import style1 from "./Company_Edit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31537dda",
  null
  
)

export default component.exports